import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, X } from "lucide-react";

export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const location = useLocation();

  // Don't show on order, checkout, or admin pages
  const hideOnPaths = ["/order", "/checkout", "/admin"];
  const shouldHide = hideOnPaths.some((p) => location.pathname.startsWith(p));

  useEffect(() => {
    if (shouldHide || dismissed) return;

    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [shouldHide, dismissed]);

  if (!visible || shouldHide || dismissed) return null;

  return (
    <div
      data-testid="floating-cta"
      className="fixed bottom-0 left-0 right-0 z-40 bg-[#0D2D54] border-t border-[#1A3D6B] py-3 px-4 shadow-[0_-4px_20px_rgba(0,0,0,0.12)] animate-fade-in-up"
      style={{ animationDuration: "0.3s" }}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="hidden sm:block">
          <p className="text-white text-sm font-medium">
            Virtual staging from <span className="text-[#758C7B]">£55 per image</span> — delivered in 48 hours
          </p>
        </div>
        <p className="sm:hidden text-white text-sm font-medium">
          From <span className="text-[#758C7B]">£55/image</span> — 48hr delivery
        </p>
        <div className="flex items-center gap-3">
          <Link
            to="/order"
            data-testid="floating-cta-btn"
            className="inline-flex items-center gap-2 bg-white text-[#0D2D54] px-5 py-2 text-sm font-semibold hover:bg-white/90 transition-all whitespace-nowrap"
          >
            Order Now
            <ArrowRight size={14} />
          </Link>
          <button
            data-testid="floating-cta-dismiss"
            onClick={() => setDismissed(true)}
            className="text-white/50 hover:text-white transition-colors"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
